import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createInputsWrapper, ErrorText, FindError, RenderEquipmentType, useGlobalStyles } from 'utils';
import { ErrMessage, Line, SelectTypeAutocomplete, ValidationInput } from 'components';
import { createLoadStyle } from './styles';
import { carrierActions, equipmentActions } from 'store';
import { TransactionGroup } from '../../../../fragments/loads/transactions';
import { carrierIntegrationEnums } from '../../../../fragments/carriers/carrierInfo/core/constants';
import { PENDING } from '../../../accounting/constants';
import { vendorEnums } from '../../../vendors';
import moment from 'moment/moment';

export const RequestACarrier = ({ info, disables, handleChange, inputs, error, setInputs, setError }) => {
  const { carriersList, equipmentList } = useSelector((state) => ({
    carriersList: state.carriers.carriersList,
    equipmentList: state.equipment.equipmentList,
  }));
  const dispatch = useDispatch();
  const globalScreens = createInputsWrapper();
  const globalStyles = useGlobalStyles();
  const classes = createLoadStyle();
  const err = FindError('NOT_CARRIER');
  const [carrierFiltered, setCarrierFiltered] = useState([]);
  const selectedVendor = info?.carrierId ? [
    {
      docketNumber: info?.carrierMC,
      companyName: info?.carrierName,
      id: info?.carrierId,
    },
  ] : [];
  const rate = inputs?.carrierTxns?.reduce((sum, i) => sum + Number(i.amount) * Number(i.qty), 0) || 0;
  const currentVendor = carriersList?.carriers?.find((i) => i?.id === inputs?.carrierId);
  const checkRequiredEquipment = currentVendor?.type === vendorEnums.FACTORED || currentVendor?.type === vendorEnums.VENDOR || currentVendor?.type === vendorEnums.INHOUSE_PROFILE;

  useEffect(() => {
    if (carriersList?.carriers?.length) {
      // const newList = carriersList?.carriers?.filter((i) => i?.doNotLoad === false && (i?.rmisRequired ? i?.rmisStatus === 'ACTIVE' : true));
      const newList = carriersList?.carriers?.filter((i) => i?.doNotLoad === false &&
        (i?.type === "CARRIER" ? (i?.onboardingSource === carrierIntegrationEnums.NONE ? true : i?.onboardingStatus === 'ACTIVE') : true ));
      setCarrierFiltered(newList);
    }
  }, [carriersList]);

  // const getEquipments = (id) => {
  //   dispatch(equipmentActions.getEquipments({ carrier: id, favorites: false, assigned: false, status: 'ACTIVE' }));
  // };


  const handleSearchVendor = (e) => {
    if (e.target.value.length > 3) {
      const params = {
        statuses: ['ACTIVE'],
        searchKey: 'companyName',
        searchValue: e.target.value,
      };
      // if (info?.vendorType) params.type = info?.vendorType;

      setTimeout(() => {
        dispatch(carrierActions.getCarriers(params));
      }, 500);
    }
  };

  // const handleSearchVendor = (e) => {
  //   if (e.target.value.length > 3) {
  //     setTimeout(() => {
  //       dispatch(carrierActions.getCarriers({
  //         statuses: ['ACTIVE'],
  //         searchKey: 'companyName',
  //         searchValue: e.target.value,
  //       }));
  //     }, 500);
  //   }
  // };

  const renderValue = (item) => {
    return `${RenderEquipmentType(item?.equipmentType)} ${item?.trailerLength ? `(${item?.trailerLength}\`)` : ''}${item?.originCity || item?.originState ? ' - ' : ''}${item?.originCity ? `${item?.originCity}${item.originCity && item.originState ? ',' : ''} ` : ''}${item?.originState ? item?.originState : ''}${item?.availableDate ? ` - ${moment.utc(item?.availableDate).format('MM/DD/YYYY')}` : ''}`;
  };

  return (
    <div className="full-width-flex-able">
      <div className={'MuiAccordionDetails-root'}>
        <Line height={'auto'} />
      </div>
      <div className="full-width">
        <div className="load-row-wrapper" style={{ marginTop: '12px' }}>
          <div className={globalScreens.basicInfoInputs} style={{ width: '100%' }}>
            <div className={classes.basicInfoInputsWrapper}>
              <SelectTypeAutocomplete
                loadType={'GET_CARRIERS'}
                style={globalStyles.simpleInput}
                name={'carrier'}
                label={'companyName'}
                type={'docketNumber'}
                title={'Vendor/MC'}
                handleSelect={handleChange}
                handleType={handleSearchVendor}
                defaultValue={inputs.carrier}
                list={
                  info && !carrierFiltered?.length ? selectedVendor :
                    carrierFiltered
                }
                disabled={disables}
                error={error}
              />
              {/*{carrierFiltered?.length ?*/}
              {/*    <SelectTypeAutocomplete*/}
              {/*        loadType={'GET_CARRIERS'}*/}
              {/*        style={globalStyles.simpleInput}*/}
              {/*        name={'carrier'}*/}
              {/*        label={'companyName'}*/}
              {/*        type={'docketNumber'}*/}
              {/*        title={'Vendor/MC*'}*/}
              {/*        handleSelect={handleChange}*/}
              {/*        defaultValue={inputs.carrier}*/}
              {/*        list={carrierFiltered}*/}
              {/*        disabled={disables}*/}
              {/*        error={error}*/}
              {/*    />*/}
              {/*    :*/}
              {/*    <SelectTypeAutocomplete*/}
              {/*        style={globalStyles.simpleInput}*/}
              {/*        title={'Vendor/MC*'}*/}
              {/*        list={[]}*/}
              {/*        disabled={disables}*/}
              {/*        error={error}*/}
              {/*    />*/}
              {/*}*/}
              <div className={classes.carrierRate}>
                <ValidationInput
                  style={globalStyles.simpleInput}
                  className={inputs.carrierRate && globalStyles.inputTextFieldBlue}
                  variant={'outlined'}
                  name={'carrierRate'}
                  label={'Rate'}
                  type={'number'}
                  typeError={error === 'carrierRate' && ErrorText.field}
                  onChange={handleChange}
                  value={
                    info?.carrier ? info?.carrierRate :
                      rate ? rate : inputs.carrierRate || '0'
                  }

                  disabled={true}
                />
              </div>

              <ValidationInput
                style={globalStyles.simpleInput}
                className={inputs.carrierReference && globalStyles.inputTextFieldBlue}
                variant={'outlined'}
                name={'carrierReference'}
                label={'Vendor Reference'}
                type={'text'}
                typeError={error === 'carrierReference' && ErrorText.field}
                onChange={handleChange}
                value={inputs?.carrierReference}
                disabled={disables}
              />

              {!checkRequiredEquipment &&
                <>
                  {equipmentList?.items?.length ?
                    <SelectTypeAutocomplete
                      loadType={'GET_EQUIPMENT'}
                      style={globalStyles.simpleInput}
                      name={'equipmentId'}
                      label={'name'}
                      title={info?.isTonu === true ? 'Assign Equipment' : `Assign Equipment${checkRequiredEquipment ? '*' : ''}`}
                      handleSelect={handleChange}
                      defaultValue={inputs.equipmentId}
                      list={equipmentList?.items}
                      disabled={disables}
                      typeError={error === 'equipmentId' && ErrorText.field}
                      error={error}
                      custom={(e) => renderValue(e)}
                    />
                    :
                    <SelectTypeAutocomplete
                      loadType={'GET_EQUIPMENT'}
                      style={globalStyles.simpleInput}
                      name={'equipmentId'}
                      title={info?.isTonu === true ? 'Assign Equipment' : `Assign Equipment${checkRequiredEquipment ? '*' : ''}`}
                      list={[]}
                      disabled={disables}
                      typeError={error === 'equipmentId' && ErrorText.field}
                      error={error}
                    />
                  }
                </>
              }


            </div>
            <div style={{ width: '50%' }}>
              <ValidationInput
                style={globalStyles.simpleInput}
                className={inputs.carrierInstruction ? classes.inputTextFieldBlue : classes.inputTextField}
                variant={'outlined'}
                name={'carrierInstruction'}
                label={'Specific Instruction'}
                type={'text'}
                multiline={true}
                Length={200}
                typeError={error === 'carrierInstruction' && ErrorText.field}
                onChange={handleChange}
                value={inputs.carrierInstruction}
                disabled={disables}
              />
              <div className={classes.maxCharacters}>
                <p>Max 200 characters</p>
              </div>
            </div>
          </div>
          {err && err.length && error === 'noLoadSub' ?
            <ErrMessage type={'Pass'} text={'Please add carrier'} /> :
            ''
          }
        </div>

        <TransactionGroup
          inputs={{ ...inputs, transactions: inputs?.carrierTxns }}
          setInputs={setInputs}
          error={
            error === 'carrierTxnType' ? 'type' :
              error === 'carrierTxnAmount' ? 'amount' :
                error === 'carrierTxnQty' ? 'qty' :
                  ''
          }
          setError={(e) => {
            setError(
              e === 'type' ? 'carrierTxnType' :
                e === 'amount' ? 'carrierTxnAmount' :
                  e === 'qty' ? 'carrierTxnQty' :
                    ''
            )
          }}
        />
      </div>
    </div>
  );
};